module.exports = __webpack_public_path__ + "img/Demo_icon.684e1fd9.png";